import { CoworldSidebarView } from "@softmax/product-ux/shell";
import { matchRoute } from "@softmax/web-addresses";
import {
  FeatureLink as Link,
  usePathname,
  useSearchParams,
} from "@softmax/web-features/navigation";

import {
  AccountMenu,
  CoworldSwitcher,
  SearchRow,
  searchHrefOf,
} from "@softmax/web-features/site";

import {
  coworldMenu,
  coworldSearchContext,
  type CoworldNav,
  type CoworldMenuItem,
  signedInHome,
} from "@softmax/web-features/site/records";

function claims({ item, path }: { item: CoworldMenuItem; path: string }) {
  const section = item.matchPrefix ?? item.href;
  return path === section || path.startsWith(`${section}/`);
}
export function CoworldSidebar({ coworld }: { coworld: CoworldNav }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const items = coworldMenu(coworld);
  const searchContext = coworldSearchContext(coworld);
  // Search keeps the originating room highlighted without calling it the current page.
  const stood =
    pathname === searchHrefOf({ coworld: searchContext })
      ? (searchParams.get("from") ?? pathname)
      : pathname;
  const route = matchRoute(stood);
  // Sibling leagues put their Play workspace one segment deeper than the default league.
  const room =
    route.area === "game" &&
    route.league !== undefined &&
    route.section === "play" &&
    !items.some((item) =>
      claims({
        item,
        path: stood,
      }),
    )
      ? coworld.playHref
      : stood;
  const viewItems = items.map((item) => {
    const active = claims({
      item,
      path: room,
    });
    return {
      ...item,
      active,
      current: active && room === pathname,
      // Only the wiki API returns a complete index suitable for an exact count.
      badge:
        item.key === "docs" && coworld.wikiPages
          ? coworld.wikiPages
          : undefined,
    };
  });
  return (
    <CoworldSidebarView
      items={viewItems}
      ariaLabel={`${coworld.name} menu`}
      homeHref={signedInHome}
      brandmarkSrc="/home/nav-brandmark-color.svg"
      links={coworld.links}
      switcher={<CoworldSwitcher coworld={coworld} />}
      search={<SearchRow variant="rail" coworld={searchContext} />}
      account={<AccountMenu anchor="rail" />}
      renderLink={(props) => <Link {...props} />}
    />
  );
}
